import React from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';
import ConversionItemContent from './ConversionItemContent/ConversionItemContent.container';

const ConversionItemPage = ({ t }) => {
    const staticNames = t?.conversionItemPage || {};

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content">
                <ConversionItemContent />
            </section>
        </React.Fragment>
    );
};

ConversionItemPage.propTypes = {
    t: PropTypes.object
};

ConversionItemPage.defaultProps = {
    t: {}
};

export default withTranslation(ConversionItemPage);